import { render, staticRenderFns } from "./VatToggle.vue?vue&type=template&id=65405666&"
import script from "./VatToggle.vue?vue&type=script&lang=js&"
export * from "./VatToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65405666')) {
      api.createRecord('65405666', component.options)
    } else {
      api.reload('65405666', component.options)
    }
    module.hot.accept("./VatToggle.vue?vue&type=template&id=65405666&", function () {
      api.rerender('65405666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/VatToggle.vue"
export default component.exports